import React, { useEffect, useState } from 'react';
import {
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  makeStyles,
  Typography,
  alpha,
  useTheme,
} from '@material-ui/core';
import PlayCircleFilledIcon from '@material-ui/icons/PlayCircleFilled';
import AccountBoxIcon from '@material-ui/icons/AccountBox';
import HelpIcon from '@material-ui/icons/Help';
import AssistentIcon from '@material-ui/icons/Assistant';
import { useTranslation } from 'react-i18next';
import { Copyright } from '../Shared';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    height: '100%',
    paddingBottom: 24,
  },
  identity: {
    padding: theme.spacing(2, 0, 6, 2),
  },
  backgroundActived: {
    '&:hover': {
      backgroundColor: theme.palette.primary.light,
    },
    '&:focus': {
      backgroundColor: theme.palette.primary.lightest,
    },
  },
  typography: {
    fontWeight: 'bold',
    marginLeft: theme.spacing(2),
  },
  activated: {
    color: theme.palette.primary.main,
  }
}));

const useStylesIcon = makeStyles(() => ({
  root: {
    minWidth: 30,
  },
}));

function SidebarHelpCenter({ currentlyTab, handleChangeCurrentlyTab }) {
  const classes = useStyles();
  const classesIcon = useStylesIcon();
  const [location, setLocation] = useState(currentlyTab);
  const { t } = useTranslation();
  const theme = useTheme();

  const handleShowComponent = (value) => {
    handleChangeCurrentlyTab(value)
  }
  useEffect(() => {
    setLocation(currentlyTab)
  }, [currentlyTab])

  return (
    <div className={classes.root}>
      <div>
        <div className={classes.acc}>
          <List>

            <ListItem
              button
              onClick={() => handleShowComponent('primeiro-acesso')}
              className={
                location === 'primeiro-acesso'
                  ? classes.backgroundActived
                  : ''
              }
            >
              <ListItemIcon classes={classesIcon}>
                <PlayCircleFilledIcon
                  htmlColor={
                    location === 'primeiro-acesso' ? theme.palette.primary.main : 'inherit'
                  }
                />
              </ListItemIcon>
              <ListItemText
                disableTypography
                primary={
                  <Typography
                    className={
                      location === 'primeiro-acesso'
                        ? classes.activated
                        : ''
                    }
                  >
                    {t('primeiro_acesso')}
                  </Typography>
                }
              />
            </ListItem>
            <ListItem
              button
              onClick={() => handleShowComponent('tutoriais')}

              className={
                location === 'tutoriais'
                  ? classes.backgroundActived
                  : ''
              }
            >
              <ListItemIcon classes={classesIcon}>
                <AssistentIcon
                  htmlColor={
                    location === 'tutoriais' ? theme.palette.primary.main : 'inherit'
                  }
                />
              </ListItemIcon>
              <ListItemText
                disableTypography
                primary={
                  <Typography
                    className={
                      location === 'tutoriais'
                        ? classes.activated
                        : ''
                    }
                  >
                    {t('tutoriais')}
                  </Typography>
                }
              />
            </ListItem>


            <ListItem
              button
              onClick={() => handleShowComponent('faq')}

              className={
                location === 'faq'
                  ? classes.backgroundActived
                  : ''
              }
            >
              <ListItemIcon classes={classesIcon}>
                <HelpIcon
                  htmlColor={
                    location === 'faq' ? theme.palette.primary.main : 'inherit'
                  }
                />
              </ListItemIcon>
              <ListItemText
                disableTypography
                primary={
                  <Typography
                    className={
                      location === 'faq'
                        ? classes.activated
                        : ''
                    }
                  >
                    {t('duvidas_frequentes')}
                  </Typography>
                }
              />
            </ListItem>


            <ListItem
              button
              onClick={() => handleShowComponent('administradores')}
              className={
                location === 'administradores'
                  ? classes.backgroundActived
                  : ''
              }
            >
              <ListItemIcon classes={classesIcon}>
                <AccountBoxIcon
                  htmlColor={
                    location === 'administradores'
                      ? theme.palette.primary.main
                      : 'inherit'
                  }
                />
              </ListItemIcon>
              <ListItemText
                primary={
                  <Typography
                    className={
                      location === 'administradores'
                        ? classes.activated
                        : ''
                    }
                  >
                    {t('administradores')}
                  </Typography>
                }
              />
            </ListItem>
          </List>
        </div>
      </div>
      <Copyright />
    </div>
  );
}

export { SidebarHelpCenter };
